package or.garden.manager.features.notes.components

import androidx.compose.runtime.Composable
import or.garden.manager.domain.model.NoteData
import org.jetbrains.compose.web.dom.*

@Composable
fun WebNoteCard(
    note: NoteData,
    onEdit: () -> Unit,
    onDelete: () -> Unit
) {
    Div({
        classes("bg-white", "rounded-2xl", "shadow-sm", "border", "border-gray-100", "p-6", "flex", "flex-col", "gap-4", "hover:shadow-md", "transition-all", "cursor-pointer")
        onClick { onEdit() }
    }) {
        Div({ classes("flex", "justify-between", "items-start") }) {
            H3({ classes("font-bold", "text-lg", "text-gray-900") }) { Text(note.title) }
            Button({
                classes("text-gray-400", "hover:text-red-500", "p-2", "rounded-lg", "transition-colors")
                onClick { 
                    it.stopImmediatePropagation()
                    onDelete() 
                }
            }) {
                I({ classes("fas", "fa-trash-alt") })
            }
        }
        
        P({
            classes("text-gray-600", "text-sm", "line-clamp-3", "flex-1")
            ref { element ->
                element.innerHTML = note.content
                onDispose { }
            }
        })

        Div({ classes("flex", "items-center", "gap-2", "mt-2") }) {
            I({ classes("far", "fa-calendar", "text-gray-400", "text-xs") })
            Span({ classes("text-xs", "text-gray-400") }) {
                Text(note.date())
            }
        }
    }
}
